'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Disclaimer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Disclaimer, _Component);

  function Disclaimer() {
    (0, _classCallCheck3.default)(this, Disclaimer);
    return (0, _possibleConstructorReturn3.default)(this, (Disclaimer.__proto__ || (0, _getPrototypeOf2.default)(Disclaimer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Disclaimer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          containerStyle = _props.containerStyle,
          textStyle = _props.textStyle;


      return _react2.default.createElement(
        'table',
        { style: { borderCollapse: 'collapse', width: '100%', padding: '0' }, 'data-component': 'Disclaimer' },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { style: (0, _extends3.default)({}, containerStyle, { padding: '10px' }) },
              _react2.default.createElement(
                'span',
                { style: textStyle },
                text
              )
            )
          )
        )
      );
    }
  }]);
  return Disclaimer;
}(_react.Component), _class.propTypes = {
  text: _react.PropTypes.string
}, _temp);
exports.default = Disclaimer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Disclaimer/Disclaimer.jsx
// module id = 125
// module chunks = 0